<template>
  <div>
    <div class="courseAdmins">
      <b-overlay :show="loadData" spinner-variant="primary" spinner-type="grow" spinner-small rounded="md">
        <b-button variant="primary" class="mb-2" size="sm" pill v-if="!createAdmin"
          @click="createAdmin = !createAdmin">Add Course Instructor</b-button>
        <div v-if="createAdmin">
          <AddAdmin :courseAdminModal="courseAdminModal" :faculties="faculties" :courseAdminList="courseAdminList"
            @addAdminStatus="addAdminStatus" />
        </div>

        <table class="table table-striped table-bordered" v-else>
         
          <thead class="thead-dark text-left">
            <tr>
              <th>Sr. No.</th>
              <th>Name</th>
              <th>Remove</th>
            </tr>
          </thead>
          <tbody>
            <tr v-for="(admin, adminIndex) in courseAdminList" :key="adminIndex">
              <td class="align-middle">
                {{ adminIndex + 1 }}
              </td>
              <td :class="{ 'align-middle': true, 'text-danger': admin.enroll_status != 'active' }">
                {{ admin.first_name || " " }} {{ admin.last_name || " " }}
              </td>
              <td class="align-middle">
                <span class="text-danger btn m-0 p-0" v-if="!admin.pivot.deleted_at" @click="deleteCourseUser(admin.pivot.id)">
                  <i class="fas fa-trash"></i>
                </span>
                <span v-else>
                  <span class="text-danger">Course Instructor removed  </span>
                  <span @click="addCourseUser(admin.pivot.id)" style="cursor: pointer;" title="Undo delete">
                      <i class="fas fa-undo text-danger" style="font-size: 10px;"></i>
                  </span>
                </span>
              </td>
            </tr>
          </tbody>
        </table>
      </b-overlay>
    </div>
  </div>
</template>

<script>
import AddAdmin from "./AddAdmin.vue";
export default {
  props: ["courseAdminModal", "faculties"],
  async created() {
    this.fetchCourseAdminList();
  },
  components: {
    AddAdmin,
  },
  data() {
    return {
      courseAdminList: [],
      loadData: false,
      createAdmin: false,
    };
  },
  methods: {
    fetchCourseAdminList() {
      this.courseAdminList = [];
      this.courseAdminList = [...this.courseAdminModal.admins];
      this.courseAdminList.sort(function (a, b) {
        return (
          a.first_name - b.first_name || a.first_name.localeCompare(b.first_name)
        );
      });
    },
    addAdminStatus(status) {
      if (status) {
        this.$emit("newCourseAdminsAdded");
      } else {
        this.createAdmin = !this.createAdmin;
      }
    },
    deleteCourseUser(userId) {
      console.log("userId",userId);
      this.loadData = true;
      let userUrl = this.$store.getters.getAPIKey.deleteCourseUser;
      let url = userUrl.replace("course_user_id", userId);
      this.$axios
        .delete(url)
        .then(() => {
          this.$toast.success("User Deleted!", {
            position: "top",
            duration: 3000,
          });
          this.fetchCourseAdminList();
          const admin = this.courseAdminList.find(user => user.pivot.id === userId);
          if (admin) {
            admin.pivot.deleted_at = 1;
          }
          this.$emit("adminRemoved", Number(this.courseAdminList.length));
          this.loadData = false;
        })
        .catch(() => {
          this.postCourses = false;
          this.$toast.error("Something went wrong, Please try again!", {
            position: "top",
            duration: 3000,
          });
          this.loadData = false;
          // console.log(error.reponse);
        });
    },
    addCourseUser(userId) {
      this.loadData = true;
      let url = `${this.$store.getters.getAPIKey.mainAPI}/courseusers/addremoveduser?courseuser_id=${userId}`;

      this.$axios
        .post(url)
        .then((reponse) => {
          this.$toast.success("User Added!", {
            position: "top",
            duration: 3000,
          });
          let admindata = reponse.data;
          this.fetchCourseAdminList();
          const admin = this.courseAdminList.find(user => user.pivot.id === userId);
          console.log();
          if (admin) {
            admin.pivot.deleted_at = admindata.deleted_at;
          }
          this.$emit("adminRemoved", Number(this.courseAdminList.length));
          this.loadData = false;
        })
        .catch(() => {
          this.postCourses = false;
          this.$toast.error("Something went wrong, Please try again!", {
            position: "top",
            duration: 3000,
          });
          this.loadData = false;
          // console.log(error.reponse);
        });
    },
  },
};
</script>
